import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

export const Table = forwardRef(({ className, ...rest }, ref) => (
  <div className="overflow-x-auto">
    {/* Hook semántico `ui-table` para la capa global de densidad compacta
        (_density-compact.scss): comprime el padding de celdas en viewports
        bajos + puntero fino. Cubre users, incidents, billing y toda vista que
        use este primitivo. */}
    <table ref={ref} {...rest} className={cn('ui-table', 'min-w-full divide-y divide-border', className)} />
  </div>
));
Table.displayName = 'Table';

export function THead({ className, ...rest }) {
  return <thead {...rest} className={cn('bg-bg-muted', className)} />;
}

export function TBody({ className, ...rest }) {
  return <tbody {...rest} className={cn('divide-y divide-border bg-bg', className)} />;
}

export function TR({ className, ...rest }) {
  return <tr {...rest} className={cn('hover:bg-bg-muted/50 transition-colors', className)} />;
}

export function TH({ className, ...rest }) {
  return (
    <th
      {...rest}
      className={cn(
        'px-4 py-3 text-left text-[11px] font-semibold text-fg-muted uppercase tracking-wider whitespace-nowrap',
        className,
      )}
    />
  );
}

export function TD({ className, ...rest }) {
  return <td {...rest} className={cn('px-4 py-3 text-sm text-fg align-top', className)} />;
}